module.exports = "<app-subsidiary-dashboard-contract-contracts></app-subsidiary-dashboard-contract-contracts>"